exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fa-phone-square{\r\n    font-size: 100px;\r\n}\r\n.offer_whatsapp{\r\n    width: 112px;\r\n    display: block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calculators/home-loan-comparison-calculator/call-to-get-offers/call-to-get-offers.component.css
// module id = 612
// module chunks = 8